var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2358_753)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33331 2.66714H4.53331C3.41321 2.66714 2.85316 2.66714 2.42533 2.88513C2.04901 3.07688 1.74305 3.38284 1.5513 3.75916C1.33331 4.18699 1.33331 4.74704 1.33331 5.86714V11.4671C1.33331 12.5872 1.33331 13.1473 1.5513 13.5751C1.74305 13.9514 2.04901 14.2574 2.42533 14.4492C2.85316 14.6671 3.41321 14.6671 4.53331 14.6671H10.1333C11.2534 14.6671 11.8135 14.6671 12.2413 14.4492C12.6176 14.2574 12.9236 13.9514 13.1153 13.5751C13.3333 13.1473 13.3333 12.5872 13.3333 11.4671V8.66714M5.3333 10.6671H6.44966C6.77578 10.6671 6.93884 10.6671 7.09229 10.6303C7.22834 10.5976 7.3584 10.5438 7.47769 10.4707C7.61225 10.3882 7.72755 10.2729 7.95815 10.0423L14.3333 3.66714C14.8856 3.11486 14.8856 2.21943 14.3333 1.66714C13.781 1.11486 12.8856 1.11486 12.3333 1.66714L5.95814 8.04231C5.72753 8.27291 5.61223 8.38821 5.52978 8.52276C5.45667 8.64206 5.4028 8.77212 5.37014 8.90817C5.3333 9.06162 5.3333 9.22468 5.3333 9.5508V10.6671Z",
    stroke: "#8B8B8B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", null, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8f3d8c5b6f5319d6726612790e357f71.svg";
export { ForwardRef as ReactComponent };